// extracted by mini-css-extract-plugin
module.exports = {"root":"BaseModal_root__MrwkN","description":"BaseModal_description__p_Vqt","form":"BaseModal_form__HrdxD","fieldset":"BaseModal_fieldset__O0fWW"};